// core
import React from 'react';
import { Link } from 'react-router-dom'
import { Provider } from "react-redux"

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// page-specific/etc.
import SchoolList from 'components/schools/SchoolList';
import TeacherList from 'components/teachers/TeacherList';

class ListEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'edit',
      working: false,
      fetching: false,

      error: '',

      productGroups: {},

      list: {
        name: '',
        descr: ''
      },

      emailsCsv: ''
    };

    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescrChange = this.handleDescrChange.bind(this);
    this.handleEmailsChange = this.handleEmailsChange.bind(this);

    this.getEmailsArray = this.getEmailsArray.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { listId } = this.props.match.params;

    console.log('List ID: ' + listId);

    if (listId) {
      this.setState({
        fetching: true
      });

      if (listId && listId != 'new') {
        API.call('GET', Settings.V2_API_URL + '/recipient-lists/' + listId, {}, (response, error) => {
          if (error) {
            this.setState({
              fetching: false,

              error: error.message + ' while gettings projects'
            });

            return false;
          }

          // convert form to object
          var list = response.data.list;
          list.form = JSON.parse(list.form);

          this.setState({
            list: list
          });
        });
      }
    }
  }

  handleTitleChange(e) {
    var name = e.target.value;

    return this.setState((prevState) => {
      prevState.list.name = name;

      return prevState;
    });
  }
  handleDescrChange(e) {
    var descr = e.target.value;

    return this.setState((prevState) => {
      prevState.list.descr = descr;

      return prevState;
    });
  }
  handleEmailsChange(e) {
    var emailsCsv = e.target.value;

    return this.setState((prevState) => {
      prevState.emailsCsv = emailsCsv;

      return prevState;
    });
  }

  getEmailsArray() {
    return this.state.emailsCsv ? this.state.emailsCsv.split("\n").filter(email => email.trim() !== '') : [];
  }

  handleSubmit() {
    this.setState({
      fetching: true,
      error: ''
    });

    let method, endpoint;
    if (this.state.list.id) {
      method = 'PUT';
      endpoint = Settings.V3_API_URL + '/recipient-lists/' + this.state.list.id;
    } else {
      method = 'POST';
      endpoint = Settings.V3_API_URL + '/recipient-lists';
    }

    const payload = this.state.list;
    if (!payload.name) {
      payload.name = 'Lista del ' + (new Date()).toString();
    }

    payload.schools = [];
    payload.teachers = [];
    Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).forEach((schoolId) => {
      payload.schools.push(schoolId);
    });
    Object.keys(this.props.appData.mailings.mailingPanelList.teachersById).forEach((teacherId) => {
      payload.teachers.push(teacherId);
    });

    payload.emails = this.getEmailsArray();

    API.call(method, endpoint, payload, (response, error) => {
      this.setState({
        fetching: false
      });

      const err = error ? error.message : response.error;

      if (err) {
        this.setState({
          error: err
        });

        return false;
      }

      this.setState({
        status: 'saved',
        list: response.data.list
      }, () => {
        if (this.props.onAfterSave) {
          this.props.onAfterSave();
        }
      });
    });
  }

  render() {
    let schools = [];
    let teachers = [];

    if (Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).length) {
      Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).slice(0, 3).forEach((id) => {
        const school = this.props.appData.mailings.mailingPanelList.schoolsById[id];

        schools.push(school);
      });
    }
    if (Object.keys(this.props.appData.mailings.mailingPanelList.teachersById).length) {
      Object.keys(this.props.appData.mailings.mailingPanelList.teachersById).slice(0, 3).forEach((id) => {
        const teacher = this.props.appData.mailings.mailingPanelList.teachersById[id];

        teachers.push(teacher);
      });
    }

    return (
      <div>
        <div className="container">
          {
            this.state.error ? (
              <div className="alert alert-danger"><h2>Oh, mamma!</h2><p>{this.state.error}</p></div>
            ) : ""
          }

          {
            this.state.status == 'edit' ? (
              <div>
                <div className="row">
                  <div className="col-md-8">
                    <h1><i className="fa fa-stream" /> {this.state.list && this.state.list.id ? "Aggiorna lista" : "Crea nuova lista"}</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    {
                      this.state.fetching || this.state.working ? <Spinner message="Attendere..." /> : ""
                    }
                  </div>
                </div>

                <div className="mt-4">
                  <div className="form-group">
                    <label for="list_editor_list_name">Nome <span className="text-danger">*</span></label>

                    <input className="form-control" type="text" id="list_editor_list_name" value={this.state.list ? this.state.list.name : ""} onChange={this.handleTitleChange} />
                  </div>
                  <div className="form-group">
                    <label for="list_editor_list_descr">Descrizione</label>

                    <textarea className="form-control" id="list_editor_list_descr" value={this.state.list ? this.state.list.descr : ""} onChange={this.handleDescrChange}></textarea>
                  </div>

                  <h2 className="mt-4">Esempio insegnanti (totale: {Object.keys(this.props.appData.mailings.mailingPanelList.teachersById).length})</h2>
                  <TeacherList
                    teachers={teachers}

                    recipientList={this.props.appData.mailings.mailingPanelList.teachersById}
                  />

                  <h2 className="mt-4">Esempio scuole (totale: {Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).length})</h2>
                  <SchoolList
                    schools={schools}

                    recipientList={this.props.appData.mailings.mailingPanelList.schoolsById}
                  />

                  <h2 className="mt-4">Destinatari hardcodati (totale: {this.getEmailsArray().length})</h2>
                  <p>Inserire email—formato 1 email per riga</p>
                  <textarea rows="10" className="form-control" onChange={this.handleEmailsChange} value={this.state.emailsCsv} />

                  <hr />

                  <p><button className="btn btn-primary" onClick={this.handleSubmit}><i className="fa fa-save mr-1" /> Salva lista</button></p>
                </div>
              </div>
            ) : this.state.status == 'saved' ? (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <h1>Lista salvata.</h1>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <h3><Link to={'/marketing/mailings/new/'}><i className="fa fa-arrow-right" /> Crea campagna</Link></h3>
                  </div>
                </div>
              </div>
            ) : ""
          }
        </div>
      </div>
    );
  }
}

export default ListEditorPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/recipients/ListEditorPage.js